import dataProvider from "@refinedev/simple-rest";
import { axiosInstance } from "./client";

const BASE = import.meta.env.VITE_API_URL ?? "http://localhost:3000";

export const createDataProvider = () => dataProvider(BASE, axiosInstance);
